var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"database":_vm.database,"table":_vm.table,"fields":_vm.fields,"views":_vm.views,"view":_vm.view,"table-loading":false,"store-prefix":"page/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }